/*
  Promotes a product card's hover image from data- attributes to real ones.

  The secondary image is display:none below the desktop breakpoint
  (component-product_card.css:79) and opacity:0 until :hover above it. Chrome
  does not defer loading="lazy" on an element with no layout box, so shipping a
  real src meant every phone downloaded an image it could never display: 250 kB
  of a cold collection load, and 2.4 MB on desktop across 40 cards that were
  never hovered.

  So the markup carries data-src/data-srcset/data-sizes and this promotes them
  on first hover or keyboard focus, on pointer devices only.
*/
(function () {
  'use strict';

  var SELECTOR = '.product-card__image--secondary[data-src], .product-card__image--secondary[data-srcset]';

  // No hover, no hover image. Phones never promote, which is the whole point.
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

  function promote(img) {
    if (!img || img.dataset.hoverPromoted) return;
    img.dataset.hoverPromoted = '1';
    // sizes before srcset, so the candidate pick happens once.
    if (img.dataset.sizes) {
      img.setAttribute('sizes', img.dataset.sizes);
      delete img.dataset.sizes;
    }
    if (img.dataset.srcset) {
      img.setAttribute('srcset', img.dataset.srcset);
      delete img.dataset.srcset;
    }
    if (img.dataset.src) {
      img.setAttribute('src', img.dataset.src);
      delete img.dataset.src;
    }
  }

  function promoteWithin(node) {
    if (!node || !node.querySelectorAll) return;
    var found = node.querySelectorAll(SELECTOR);
    for (var i = 0; i < found.length; i++) promote(found[i]);
  }

  function onEnter(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var card = target.closest('.product-card');
    if (card) promoteWithin(card);
  }

  // pointerover and focusin both bubble, so one listener covers cards added later.
  document.addEventListener('pointerover', onEnter, { passive: true });
  document.addEventListener('focusin', onEnter, { passive: true });
})();
